import React from 'react';
import '../css/style.css';

function Resume() {
  return (
    <div className="container">
      <h1 className="section-title">Resume</h1>

      <div className="text-center mb-4">
        <a href="https://drive.google.com/file/d/1uxw3PVNpgGtZZoScpBdyWt06jwLYZzUw/view" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download Resume (PDF)</a>
      </div>

      <div className="resume-section">
        <h2 className="h3 mb-4">Technical Skills</h2>
        <div className="row">
            <div className="col-md-4">
                <div className="skill-category">
                    <h3 className="h5">Programming</h3>
                    <p>Python, C++, SQL, KQL, R, HTML/CSS/JavaScript</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="skill-category">
                    <h3 className="h5">Frameworks & Libraries</h3>
                    <p>Django, PyTorch, scikit-learn, NumPy, Pandas, Matplotlib</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="skill-category">
                    <h3 className="h5">Cloud & DevOps</h3>
                    <p>AWS, Azure, Docker, Git</p>
                </div>
            </div>
        </div>

        <div className="row mt-4">
            <div className="col-md-6">
                <div className="skill-category">
                    <h3 className="h5">Security Domains</h3>
                    <p>Security Operations, Incident Response, Detection Engineering, Threat Modeling, Threat Intelligence, Risk Assessment, IAM</p>
                </div>
            </div>
            <div className="col-md-6">
                <div className="skill-category">
                    <h3 className="h5">Security Tools</h3>
                    <p>SIEM (Sentinel, Panther), EDR (Defender, CrowdStrike), Netskope, Abnormal Security, Wireshark, WIZ, CloudFlare, Semgrep</p>
                </div>
            </div>
        </div>
      </div>

      <div className="resume-section mt-5">
        <h2 className="h3 mb-4">Professional Experience</h2>
        <div className="experience-item">
            <h3>Security Engineering Intern</h3>
            <p className="text-muted">Sigma Computing Inc, San Francisco, USA | Jun 2025 – Sept 2025</p>
            <ul>
                <li>Designed a fully automated CTI pipeline ingesting 100K+ IOCs/day, resulting in $80K annual savings</li>
                <li>Launched 12 phishing attack simulations in SANS</li>
                <li>Developed custom detections on SIEM platform, reducing false positives by 20%</li>
                <li>Validated 100% Azure log coverage in Log Analytics and Panther</li>
            </ul>
        </div>

        <div className="experience-item">
            <h3>Security Operations Analyst</h3>
            <p className="text-muted">Deloitte & Touche LLP, Bengaluru, India | Jan 2023 – Aug 2024</p>
            <ul>
                <li>Reduced 90% of impact during a massive cyberattack by analyzing 10,000+ assets</li>
                <li>Spearheaded rapid incident response for a trojan attack, successfully remediating 200+ endpoints within 4 days</li>
                <li>Automated 16+ repetitive SOC tasks using Python and Sentinel APIs</li>
            </ul>
        </div>

        <div className="experience-item">
            <h3>Solution Delivery Analyst</h3>
            <p className="text-muted">Deloitte India (Offices of the US), Bengaluru, India | Jul 2022 - Dec 2022</p>
            <ul>
                <li>Delivered 20% compliance boost by developing secure identity controls</li>
                <li>Achieved 25% faster deployments through Azure DevOps pipeline optimization</li>
                <li>Designed and implemented scalable IAM policies supporting 500+ users across the organization</li>
            </ul>
        </div>
      </div>
    </div>
  );
}

export default Resume;
